import {
  selectActingUser,
  selectCompanyName,
  selectEmail,
  selectIsBossOrSalesBossLevel,
  selectUserHasIterableEmail,
  viewAsUserRequest,
} from 'core/userContext';
import { fetchAllOrganizationsRequest } from 'modules/allOrganizations/actions';
import { toggleNav } from 'modules/nav';
import { ProjectMetadata } from 'modules/nav/components/ProjectMetadata';
import { SLIDER_MENUS } from 'modules/nav/constants';
import { SyntheticEvent, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { BossAnnouncement } from 'ui/announcement';
import { Body2 } from 'ui/theme';

const StyledBody = styled(Body2)`
  color: inherit;
`;

export const BossCallout = () => {
  const dispatch = useDispatch();
  const email = useSelector(selectEmail);
  const isBossOrSalesBossLevel = useSelector(selectIsBossOrSalesBossLevel);
  const actingUser = useSelector(selectActingUser);
  const hasIterableEmail = useSelector(selectUserHasIterableEmail);
  const companyName = useSelector(selectCompanyName);

  const shouldDisplayBausImpersonationWarning =
    isBossOrSalesBossLevel && actingUser !== email && !hasIterableEmail;

  const onClickBoss = (e: SyntheticEvent) => {
    dispatch(toggleNav(SLIDER_MENUS.OPEN_BOSS));
    e.stopPropagation();
  };

  const onClickImpersonate = () => {
    dispatch(viewAsUserRequest('founders@iterable.com'));
  };

  useEffect(() => {
    if (isBossOrSalesBossLevel) dispatch(fetchAllOrganizationsRequest() as any);
  }, [isBossOrSalesBossLevel, dispatch]);

  if (!isBossOrSalesBossLevel) return null;
  return (
    <BossAnnouncement
      isImpersonating={shouldDisplayBausImpersonationWarning}
      onClickBoss={onClickBoss}
      onClickImpersonate={onClickImpersonate}
      ProjectMetadataSlot={<ProjectMetadata />}
    >
      <StyledBody>
        <span data-test="boss-announcement-email">{email}</span>&nbsp;•&nbsp;
        <span>{companyName}</span>
      </StyledBody>
    </BossAnnouncement>
  );
};
